import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sigv-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
